import { Navigate } from "react-router-dom";
import { useHolidayActive } from "../lib/holidayApi";
import HolidayMatProgram from "../pages/HolidayMatProgram";

export const HOLIDAY_FALLBACK = "/products/custom-logos/spectra-print-h-d";

export function HolidayGate() {
  const active = useHolidayActive();
  if (active === null) return <div className="min-h-[60vh]" data-testid="holiday-gate-loading" />;
  return active ? <HolidayMatProgram /> : <Navigate to={HOLIDAY_FALLBACK} replace />;
}
